import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0004',
    ecrans: ['00-2'],
    params: ['id']
});
